import React, { useState, useEffect  } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import "../Style/Dashboard.css";
import "../Style/AssignRole.css";
import { UserCog, Users, Building, Save, Calendar, CalendarCheck } from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../Apis/apiConfig";
import axios from "axios";

const AddVouchers = () => {
  const navigate = useNavigate();
  const [selectedRole] = useState("Add Vouchers");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [unitNo, setUnitNo] = useState([])


  const [formData, setFormData] = useState({
    companyName: "",
    vouchercode: "",
    employeeName: "",
    unitNo: "",
    startDate: "",
    endDate: "",
    agree: false,
  });

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const societyName = localStorage.getItem("society") || "";

    if (
      !formData.companyName ||
      !formData.vouchercode ||
      !formData.employeeName ||
      !formData.startDate ||
      !formData.endDate
    ) {
      toast.error("Please fill in all required fields.");
      setLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const url = new URL(`${BASE_URL}/vouchers/add-vouchers`);
      url.searchParams.append("companyName", formData.companyName);
      url.searchParams.append("voucherCode", formData.vouchercode);
      url.searchParams.append("societyName", societyName);
      // url.searchParams.append("unitNo", formData.unitNo);
      if (formData.unitNo) {
       url.searchParams.append("unitNo", formData.unitNo);
      }
      url.searchParams.append("employee", formData.employeeName);
      url.searchParams.append("startDate", formData.startDate);
      url.searchParams.append("endDate", formData.endDate);

      const res = await fetch(url.toString(), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.text();
      if (!res.ok) throw new Error(data || "Server error");

      toast.success(data || "Voucher added successfully!");

      setFormData({
        companyName: "",
        vouchercode: "",
        employeeName: "",
        unitNo: "",
        startDate: "",
        endDate: "",
        agree: false,
      });
    } catch (err) {
      setError(err.message || "Server error");
      toast.error(err.message || "Server error");
    } finally {
      setLoading(false);
    }
  };

   const token = localStorage.getItem("token");
    const society = localStorage.getItem("society");
  
    useEffect(() => {
      const fetchFlats = async () => {
        try {
          const resp = await axios.get(
            `${BASE_URL}/api/member/get-list?society=${encodeURIComponent(society)}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          setUnitNo(resp.data || []);
    
        } catch (err) {
          console.error("fetch flats error:", err);
          setError("Failed to fetch flats.");
        }
      };
      if (token && society) fetchFlats();
    }, [token, society]);
  

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

        <main className="content-area">
          <SubHeader />

          <div className="assign-role-page">
            <section className="assign-content-modern">
              <div className="assign-header-modern">
                <div className="assign-title-group">
                  <UserCog size={22} />
                  <h1>{selectedRole}</h1>
                </div>
              </div>

              <div className="assign-body-modern">
                <div className="create-assign-wrapper-modern">
                  <form className="create-assign-form-modern" onSubmit={handleSubmit}>
                    <div className="form-grid-assign">

                      <div className="form-field-assign">
                        <label className="form-label-assign">
                          <UserCog size={16} />
                          <span>Company Name</span>
                          <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="companyName"
                          value={formData.companyName}
                          onChange={handleChange}
                          className="form-input-assign"
                          placeholder="Enter Company Name"
                        />
                      </div>

                      <div className="form-field-assign">
                        <label className="form-label-assign">
                          <Users size={16} />
                          <span>Voucher Code</span>
                          <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="vouchercode"
                          value={formData.vouchercode}
                          onChange={handleChange}
                          className="form-input-assign"
                          placeholder="Enter Voucher Code"
                        />
                      </div>

                      <div className="form-field-assign">
                        <label className="form-label-assign">
                          <Users size={16} />
                          <span>Employee Name / Member Name</span>
                          <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="employeeName"
                          value={formData.employeeName}
                          onChange={handleChange}
                          className="form-input-assign"
                          placeholder="Enter Employee Name"
                        />
                      </div>

                      <div className="form-field-assign">
                        <label className="form-label-assign">
                          <Building size={16} />
                       <span>Unit No (Optional)</span>
                          {/* <span className="required">*</span> */}
                        </label>
                       <select
                        name="unitNo"
                        value={formData.unitNo}
                        onChange={handleChange}
                        className="form-input-assign"
                      >
                        <option value="">Select Unit No</option>
                        {unitNo.map((flat) => (
                          <option key={flat.id} value={flat.unit_no}>
                            {flat.unit_no}
                          </option>
                        ))}
                      </select>
                      </div>

                      <div className="form-field-assign">
                        <label className="form-label-assign">
                          <Calendar size={16} />
                          <span>Start Date</span>
                          <span className="required">*</span>
                        </label>
                        <input
                          type="date"
                          name="startDate"
                          value={formData.startDate}
                          onChange={handleChange}
                          className="form-input-assign"
                          placeholder="Select Start Date"
                        />
                      </div>

                      <div className="form-field-assign">
                        <label className="form-label-assign">
                          <CalendarCheck size={16} />
                          <span>End Date</span>
                          <span className="required">*</span>
                        </label>
                        <input
                          type="date"
                          name="endDate"
                          value={formData.endDate}
                          onChange={handleChange}
                          className="form-input-assign"
                          placeholder="Select End Date"
                        />
                      </div>

                    </div>

                    <div className="form-actions-assign">
                      <button type="submit" className="submit-btn-assign" disabled={loading}>
                        <Save size={18} />
                        <span>{loading ? "Submitting..." : "Add Voucher"}</span>
                      </button>
                    </div>

                    {error && <div className="error-message-assign global-error">{error}</div>}
                  </form>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AddVouchers;
